export default function (type, payload = {}) {
  return { type, ...payload };
}
